/** @ng2api @module state */
/** */
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ui-router-ng2/lib/interface.js
// module id = 889
// module chunks = 4